<template>
  <div>
    <div class="clearfix mt-3 mb-3" v-if="answer._id">
      <div class="page-title float-left">
        <mdb-badge> 필답 평가 채점</mdb-badge>
        {{test.subject}}
        <span v-if="test.subject != test.name"> / {{test.name}} </span>
      </div>
      <div class="float-right">
        <mdb-btn class="p-2" icon="undo" @click="onBack">목록</mdb-btn>
        <mdb-btn v-if="isStaff" color="primary" class="p-2" icon="edit" @click="onMark">재채점</mdb-btn>
        <mdb-btn v-if="isStaff" color="danger" class="p-2" icon="trash" @click="onDelete">삭제</mdb-btn>
      </div>
    </div>
    <div v-if="answer._id && test._id">
      <div class="sub-title">점수: {{answer.score}} 점</div>
      <div v-for="(t, tx) in test.test" :key="t._id" class="mb-3">
        <div class="sub-title my-3 underline"><mdb-icon icon="chalkboard" /> {{t.unitName}}</div>
        <div v-for="(q, qx) in t.questions" :key="q._id" class="mb-3">
          <question-view :question="q" :answer="answer.testAnswers[tx].answers[qx]" :num="qx"/>
        </div>
      </div>
    </div>
    <div class="text-right">
        <mdb-btn class="p-2" icon="undo" @click="onBack">목록</mdb-btn>
        <mdb-btn v-if="isStaff" color="primary" class="p-2" icon="edit" @click="onMark">재채점</mdb-btn>
        <mdb-btn v-if="isStaff" color="danger" class="p-2" icon="trash" @click="onDelete">삭제</mdb-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FolderLabel from '@/components/common/FolderLabel.vue'
import TestStatus from '@/components/test/TestStatus.vue';
import QuestionView from '@/components/test/QuestionView.vue';
export default {
  components: { QuestionView },
  name: 'StaffWritingTestView',
  computed: mapGetters('auth', ['isStaff']),
  data: () => ({
    result: {},
    test: {},
    answer: {}
  }),
  methods: {
    onBack () {
      this.$router.back()
    },
    async onDelete () {
      if (!confirm('삭제할까요')) return
      await this.answer.delete()
      this.$router.back()
    },
    async onMark () {
      if (!confirm('재체점할까요')) return
      this.answer.mark(this.test.test, this.answer.teacher)
      await this.answer.save()
    }
  },
  async created () {
    const query = this.$route.query
    const { test, answer } = this.$route.query
    this.test = await this.$WritingTest.get(test)
    this.answer = await this.$WritingTestAnswer.get(answer)
    // console.log('writing -----', this.test, this.answer)
  }
}
</script>
